import { init as initApm } from '@elastic/apm-rum'

if (
  process.env.NEXT_PUBLIC_CI_PROJECT_NAME &&
  process.env.NEXT_PUBLIC_CI_PIPELINE_ID &&
  process.env.NEXT_PUBLIC_GIT_BRANCH
) {
  const serverUrl = 'https://apm-rum.inf.miui.com'
  const serviceName = process.env.NEXT_PUBLIC_CI_PROJECT_NAME
  const serviceVersion = process.env.NEXT_PUBLIC_CI_PIPELINE_ID
  const environment =
    process.env.NEXT_PUBLIC_GIT_BRANCH === 'master' ? 'production' : 'staging'

  const apm = initApm({
    serverUrl,
    serviceName,
    serviceVersion,
    environment,
  })

  apm.addLabels({
    group: 'mig1-sec-fe',
  })

  class ConsoleError extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    constructor(message, name) {
      super(message)

      this.name = name
      // 去掉一层stack
      this.stack = this.stack.replace(/^ {4}at .*\n/m, '')
    }
  }

  let inCaptureError = false

  const patchConsole = (level) => {
    const origMethod = console[level]
    const levelErrorName = {
      error: 'ConsoleError',
      warn: 'ConsoleWarning',
    }
    const errorName = levelErrorName[level]

    if (!errorName) {
      return
    }

    console[level] = (...args) => {
      try {
        let error = args[0]

        if (error instanceof Error) {
          error.message = `${error.name}: ${error.message}`
          error.name = errorName
        } else {
          error = new ConsoleError(args[0], errorName)
        }

        // 避免captureError里又调用console导致死循环
        if (!inCaptureError) {
          inCaptureError = true
          apm.captureError(error)
        }
      } catch (e) {
      } finally {
        origMethod.apply(console, args)
        inCaptureError = false
      }
    }
  }

  patchConsole('error')
  patchConsole('warn')
}
